import React, { forwardRef, memo, ReactNode } from 'react';

import { TextProps as TextGenericProps } from '../TextGeneric/TextGenericWithSkin';
import { TextGenericWithSkin } from '../TextGeneric/TextGenericWithSkin';

import { textSkinSizes } from './utils';
import { TextSize } from './types';

export interface TextProps extends Omit<TextGenericProps, 'textSize' | 'skinSize' | 'caption' | 'as'> {
    /**
     * Содержимое
     */
    children?: ReactNode;

    /**
     * Размер текста
     * @default m
     */
    size?: TextSize;
}

export type TextRenderFunction = (props: TextProps) => ReactNode;

/**
 * Компонент для создания строчного текста (span)
 */
export const Text = memo(
    forwardRef<HTMLElement, TextProps>(function Text(
        { className, children, size = 'm', color = 'gray', ...props },
        ref,
    ) {
        const skinSize = textSkinSizes[size];
        return (
            <TextGenericWithSkin
                {...props}
                className={className}
                color={color}
                textSize={'current-main'}
                skinSize={skinSize}
                as="span"
                ref={ref}
            >
                {children}
            </TextGenericWithSkin>
        );
    }),
);
